import styles from './styles.module.scss';

type Props = {
  displayName: string;
  signOut: () => void;
  children: React.ReactNode;
};

export const SideMenuFooter: React.FC<Props> = ({ displayName, signOut, children }) => (
  <div className={styles.SideMenuFooter}>
    <div className={styles.SideMenuFooter__DisplayName}>{displayName}</div>
    <button className={styles.SideMenuFooter__LogoutButton} onClick={signOut}>
      ログアウト
    </button>
    {children}
  </div>
);
